export default "__VITE_ASSET__CQakOGp6__"